import { RootState } from '../types'

export const getUserchats = (state: RootState) => state.userChats.userchats

export const getTotalUserChats = (state: RootState) => state.userChats.count
